import config from "../config";
import terms from "../terms";
var axios = config();

export default {
  getAllOpportunities(termId) {
    return axios.get("/api/Placements/GetActiveOpportunities?" + termId);
  },

  getOpportunitiesForStudent(asurite) {
    return axios.get(
      "/api/StudentOpportunities/GetStudentOpportunitiesByStudent",
      { params: { asurite: asurite } }
    );
  },
  getOpenOpportunitiesForStudent(asurite) {
    return axios.get("/api/Opportunities/GetOpenOpportunitiesByAsurite", {
      params: { asurite: asurite }
    });
  },
  getStudentInformation(asurite) {
    return axios.get(
      "/api/StudentOpportunities/GetStudentInformationByStudent",
      { params: { Asurite: asurite } }
    );
  },
  getOpportunityForStudent(opportunityId, asurite) {
    return axios.get("/api/Opportunities/GetOpportunityByIdAndAsurite", {
      params: { id: opportunityId, asuriteId: asurite }
    });
  },

  getStudentOpportunity(id) {
    return axios.get("/api/StudentOpportunities/GetStudentOpportunityById", {
      params: { id: id }
    });
  },
  getStudentOpportunityAdditionalMaterialStatuses() {
    return axios.get(
      "/api/StudentOpportunities/GetStudentOpportunityAdditionalMaterialStatuses",
      {}
    );
  },
  getOpportunityCategories() {
    return axios.get("/api/OpportunityCategories/GetOpportunityCategories", {});
  },
  getOpportunityTypes() {
    return axios.get("/api/Opportunities/GetOpportunityTypes", {});
  },

  getInternshipCourses() {
    return axios.get("/api/Opportunities/GetInternshipCourses", {});
  },
  getOpportunityFiles(opportunityId) {
    return axios.get("/api/Opportunities/GetActiveOpportunityFiles", {
      params: { id: opportunityId }
    });
  },
  getAdditionalMaterial(name) {
    return axios.get("/api/AdditionalMaterialTypes/?name=" + name);
  },
  postAddOpportunity(opportunityId, asurite) {
    return axios.post("/api/StudentOpportunities/PostStudentOpportunity", {
      OpportunityId: opportunityId,
      AsuriteId: asurite
    });
  },
  postRemoveStudentOpportunity(opportunityId, asurite) {
    return axios.post(
      "/api/StudentOpportunities/RemoveStudentOpportunity?StudentOpportunityId=" +
      opportunityId +
      "&Asurite=" +
      asurite,
      {}
    );
  },
  postSetPrimaryIntent(opportunityId, asurite) {
    return axios.post(
      "/api/StudentOpportunities/SetPrimaryIntent?StudentOpportunityId=" +
      opportunityId +
      "&Asurite=" +
      asurite,
      {}
    );
  },
  postUpdateJobDetails(studentOpportunity, asurite) {
    return axios.post(
      "/api/StudentOpportunities/updateJobDetails?Asurite=" + asurite,
      studentOpportunity
    );
  },
  postSetAdditionalMaterialStatus(materialId, statusId) {
    return axios.post(
      "/api/StudentOpportunities/SetFileStatus?StudentOpportunityAdditionalMaterialId=" +
      materialId +
      "&StatusId=" +
      statusId
    );
  },
  postSubmit(materialId) {
    return axios.post(
      "/api/StudentOpportunities/Submit?StudentOpportunityAdditionalMaterialId=" +
      materialId
    );
  },
  postFile(formData, files) {
    return axios({
      method: "POST",
      url: "/api/StudentOpportunities/AddFile",
      transformRequest: function (data) {
        var formData = new FormData();
        // need to convert our json object to a string version of json otherwise
        // the browser will do a 'toString()' on the object which will result
        // in the value '[Object object]' on the server.
        formData.append("data", JSON.stringify(data.data));
        //now add all of the assigned files
        for (var i = 0; i < data.files.length; i++) {
          //add each file to the form data and iteratively name them
          formData.append("file" + i, data.files[i]);
        }
        return formData;
      },
      data: { data: formData, files: files } // pass in data as strings
      //headers: { 'Content-Type': undefined }  // set the headers so angular passing info as form data (not request payload)
    });
  },
  postInformationUpdate(note) {
    return axios.post("/api/InformationUpdates/CreateUpdate", note);
  },
  postInformationUpdateEmail(informationUpdateId) {
    return axios.post(
      "/api/InformationUpdates/CreateInformationUpdateEmail/" +
      informationUpdateId
    );
  },
  getGenerateAdditionalMaterialDocument(data) {
    return axios.get("/api/Downloads/GenerateAdditionalMaterial", data);
  },
  postStudentOpportunityContact(data) {
    return axios.post(
      "/api/StudentOpportunities/AddStudentOpportunityContact",
      data
    );
  },
  createILASubmissionEmail(studentOpportunityId) {
    return axios.post(
      "/api/StudentOpportunities/CreateILASubmissionEmail/" +
      studentOpportunityId
    );
  },
  postCallbackRequest(route, studentOpportunityId) {
    return axios.post(route + studentOpportunityId);
  },
  postStudentOpportunityHours(data) {
    return axios.post(
      "/api/StudentOpportunities/UpdateStudentOpportunityHours",
      data
    );
  }
};
